import { useTranslation } from 'react-i18next';

import { Button, Menu } from '@any-ui-react/core';

import { PlusIcon } from '@anyx/shared-icons';

export interface AddBlockDropdownButtonProps<T extends string> {
  /** button label */
  label?: string;
  /** dropdown blocks */
  blocks: T[];
  /** trigger when select a block from dropdown */
  onAdd: (type: T) => void;
  /** node to be displayed as dropdown item */
  renderBlockNode?: (type: T) => React.ReactNode;
}

export function AddBlockDropdownButton<T extends string>({
  label,
  blocks = [],
  onAdd,
  renderBlockNode,
}: AddBlockDropdownButtonProps<T>) {
  const { t } = useTranslation('shared');

  return (
    <Menu position="bottom-start" shadow="sm">
      <Menu.Target>
        <Button size="md" variant="default" leftSection={<PlusIcon className="h-4 w-4" />}>
          {label ||
            t('shared.action.add', {
              entity: t('shared.entity.block', { count: 1 }),
            })}
        </Button>
      </Menu.Target>

      <Menu.Dropdown className="min-w-[232px]">
        {blocks.map((type) => {
          return (
            <Menu.Item
              key={type}
              className="text-gray-7 hover:text-gray-9"
              onClick={() => onAdd(type)}
            >
              {renderBlockNode ? renderBlockNode(type) : <span>{type}</span>}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
